type ContentObject = Record<string, unknown>;

const asList = (value: unknown): unknown[] => {
  if (Array.isArray(value)) return value;
  if (typeof value !== "string") return [];
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const countWhere = (value: unknown, key: string): number =>
  asList(value).filter((item) => (item as ContentObject | null)?.[key] === true).length;

const toNumber = (value: unknown): number => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const SCORE_MAX_BY_MODEL: Record<string, (object: ContentObject) => number> = {
  "content-quizz-1": () => 1,
  "content-quizz-2": () => 1,
  "content-photo-catch": () => 1,
  "content-danger-catch": () => 1,
  "content-yes-no-question": () => 1,
  "content-avatar-ai-persona": () => 1,
  "content-quizz-3": (o) => asList(o.correct_answers).filter((v) => v === true).length,
  "content-quizz-image-multiple": (o) => countWhere(o.list_answers, "is_right"),
  "content-quizz-sort": (o) => asList(o.answers).length,
  "content-random-quizz": (o) => Math.min(toNumber(o.nb_questions), asList(o.questions).length),
  "content-speech-to-check": (o) => asList(o.keywords_info).length,
  "content-zone-detect": (o) => countWhere(o.hotspot_info, "is_true_response"),
  "content-vr-locator": (o) => countWhere(o.hotspot_info, "is_true_response"),
  "content-zone-sort": (o) => asList(o.hotspot_info).length,
  "content-fire-extinguisher": (o) => asList(o.hotspot_infos).length,
  "content-element-catch": (o) =>
    asList(o.element_list).reduce<number>((sum, item) => {
      const element = (item ?? {}) as ContentObject;
      return sum + toNumber(element.score) * toNumber(element.count);
    }, 0),
};

export const computeScoreMax = (modelName: string, object: ContentObject): number | undefined =>
  SCORE_MAX_BY_MODEL[modelName]?.(object);
